/* Western Riding Co. — interactions du thème (sans dépendance). */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- Textes traduits (window.wrcStrings, rendu par la section produit depuis locales/*.json) ---------- */
  function decodeEntities(s) { const t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function str(key, fallback, vars) {
    const all = window.wrcStrings || {};
    let s = typeof all[key] === 'string' && all[key] ? decodeEntities(all[key]) : fallback;
    if (vars) Object.keys(vars).forEach(k => { s = s.split('[' + k + ']').join(vars[k]); });
    return s;
  }

  /* ---------- Utilitaires ---------- */
  function formatMoney(cents, format) {
    const value = (cents / 100);
    const fmt = (format || '{{amount_with_comma_separator}} €');
    const withSep = (dec, thou) => {
      const parts = value.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount': return withSep('.', ',');
        case 'amount_no_decimals': return Math.round(value).toLocaleString('en');
        case 'amount_with_comma_separator': return withSep(',', '.');
        case 'amount_no_decimals_with_comma_separator': return Math.round(value).toLocaleString('de');
        case 'amount_with_space_separator': return withSep(',', ' ');
        default: return withSep(',', ' ');
      }
    });
  }
  function parseRules(text) {
    return (text || '').split(/\n|;/).map(l => l.trim()).filter(Boolean).map(l => {
      const m = l.match(/^(\d+(?:[.,]\d+)?)\s*-\s*(\d+(?:[.,]\d+)?)\s*=\s*(.+)$/);
      return m ? { min: parseFloat(m[1].replace(',', '.')), max: parseFloat(m[2].replace(',', '.')), out: m[3].trim() } : null;
    }).filter(Boolean);
  }
  function applyRules(rules, v) {
    const r = rules.find(x => v >= x.min && v <= x.max);
    return r ? r.out : '';
  }
  function addBusinessDays(d, n) {
    d = new Date(d);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
    return d;
  }
  let toastTimer;
  function toast(text) {
    const t = $('[data-w-toast]');
    if (!t) return;
    $('[data-w-toast-text]', t).textContent = text;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-on'), 3500);
  }
  async function refreshCartCount() {
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } });
      const c = await r.json();
      $$('[data-w-cart-count]').forEach(el => { el.textContent = c.item_count; el.dataset.count = c.item_count; });
    } catch (e) { /* le compteur se met à jour au prochain chargement */ }
  }
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- En-tête : tiroir mobile et recherche ---------- */
  function initHeader() {
    const drawer = $('[data-w-drawer]');
    const open = $('[data-w-drawer-open]');
    if (drawer && open) {
      const close = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); open.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; open.focus(); };
      open.addEventListener('click', () => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); open.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; const f = $('a,button,input', drawer); f && f.focus(); });
      drawer.addEventListener('click', e => { if (e.target.closest('[data-w-drawer-close]')) close(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    }
    const st = $('[data-w-search-toggle]'), sb = $('[data-w-search]');
    if (st && sb) st.addEventListener('click', () => {
      const on = sb.classList.toggle('is-open');
      st.setAttribute('aria-expanded', on);
      if (on) $('input[type=search]', sb).focus();
    });
  }

  /* ---------- Méga-menu à icônes : univers (Le cheval / Le cavalier) et groupes (Seller, Brider…) ---------- */
  function initMega2() {
    $$('[data-w-mega2]').forEach(mega => {
      const showGroup = (u, g) => {
        $$('[data-w-mm-items]', mega).forEach(p => { p.hidden = p.dataset.wMmItems !== u + '-' + g; });
        $$('[data-w-mm-g]', mega).forEach(b => b.setAttribute('aria-current', b.dataset.wMmG === u + '-' + g));
      };
      const showUniverse = u => {
        $$('[data-w-mm-u]', mega).forEach(b => b.setAttribute('aria-pressed', b.dataset.wMmU === u));
        $$('[data-w-mm-groups]', mega).forEach(p => { p.hidden = p.dataset.wMmGroups !== u; });
        showGroup(u, '0');
      };
      mega.addEventListener('click', e => {
        const ub = e.target.closest('[data-w-mm-u]');
        if (ub) { showUniverse(ub.dataset.wMmU); return; }
        const gb = e.target.closest('[data-w-mm-g]');
        if (gb) { const [u, g] = gb.dataset.wMmG.split('-'); showGroup(u, g); return; }
        if (e.target.closest('a') && document.activeElement) document.activeElement.blur();
      });
      mega.addEventListener('mouseover', e => {
        const gb = e.target.closest('[data-w-mm-g]');
        if (gb && gb.getAttribute('aria-current') !== 'true') { const [u, g] = gb.dataset.wMmG.split('-'); showGroup(u, g); }
      });
      mega.addEventListener('focusin', e => {
        const gb = e.target.closest('[data-w-mm-g]');
        if (gb && gb.getAttribute('aria-current') !== 'true') { const [u, g] = gb.dataset.wMmG.split('-'); showGroup(u, g); }
      });
    });
  }

  /* ---------- Scène parallaxe : calques à vitesses différentes, étapes et barre de progression ---------- */
  function initParallax() {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-w-plx]').forEach(sec => {
      const steps = $$('.w-plx__steps li', sec);
      if (reduce) { steps.forEach(s => s.classList.add('is-on')); return; }
      const layers = $$('[data-speed]', sec), bar = $('.w-plx__prog i', sec);
      let ticking = false, visible = true;
      function frame() {
        ticking = false;
        const r = sec.getBoundingClientRect(), vh = innerHeight, total = Math.max(1, r.height - vh);
        const p = Math.min(1, Math.max(0, -r.top / total));
        layers.forEach(l => { l.style.transform = 'translate3d(0,' + (p * (+l.dataset.speed) * vh).toFixed(1) + 'px,0)'; });
        const i = Math.min(steps.length - 1, Math.floor(p * steps.length * 0.999));
        steps.forEach((s, k) => s.classList.toggle('is-on', k === i));
        if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { visible = en.isIntersecting; if (visible) frame(); }).observe(sec);
      addEventListener('scroll', () => { if (visible && !ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
      addEventListener('resize', frame);
      frame();
    });
  }

  /* ---------- Lettre : vérification de l'adresse avant envoi, erreur sous le champ ---------- */
  function initNewsletter() {
    $$('form[data-w-news]').forEach(form => {
      const input = $('input[type=email]', form), err = $('[data-w-news-err]', form);
      if (!input || !err) return;
      const ok = () => input.value.trim() !== '' && input.checkValidity();
      form.addEventListener('submit', e => {
        if (ok()) { err.hidden = true; input.setAttribute('aria-invalid', 'false'); return; }
        e.preventDefault();
        err.textContent = err.dataset.msg; err.hidden = false;
        input.setAttribute('aria-invalid', 'true'); input.focus();
      });
      input.addEventListener('input', () => { if (input.getAttribute('aria-invalid') === 'true' && ok()) { err.hidden = true; input.setAttribute('aria-invalid', 'false'); } });
    });
  }

  /* ---------- Calculateur de taille (accueil, bandeau de collection, fiche produit) — v7 ----------
     Boutons de mode : data-rules « min-max=Résultat|clé » (séparées par ; ou retour ligne), data-min/max/step/default,
     data-round (« up » = arrondi à l'entier supérieur), data-note, data-nores. {+N} dans le résultat = mesure + N.
     La clé sert à proposer la variante correspondante sur la fiche produit (bouton data-w-fit-pick). */
  function fmtNum(n) { return (Math.round(n * 10) / 10).toLocaleString(document.documentElement.lang || 'fr', { maximumFractionDigits: 1 }); }
  function fillTokens(s, v, raw) {
    return s.replace(/\{([+-]\d+(?:\.\d+)?)\}/g, (m, d) => { const n = Math.round((v + parseFloat(d)) * 10) / 10; return raw ? String(n) : fmtNum(n); });
  }
  function fitRound(v, step, mode) {
    if (mode === 'up') return Math.ceil(v - 1e-9);
    const s = step > 0 ? step : 1;
    return Math.round(v / s) * s;
  }
  function findSizeRadio(key) {
    if (!key) return null;
    const radios = $$('[data-w-product] [data-w-option] input[type=radio]');
    if (/^\d+(\.\d+)?$/.test(key)) {
      const n = parseFloat(key);
      return radios.find(r => { const m = r.value.match(/^\s*(\d+(?:[.,]\d+)?)/); return m && Math.abs(parseFloat(m[1].replace(',', '.')) - n) < 0.01; }) || null;
    }
    const k = key.toLowerCase();
    return radios.find(r => r.value.toLowerCase().includes(k)) || null;
  }
  function initFitTool() {
    $$('[data-w-fit]').forEach(sec => {
      const range = $('input[type=range]', sec), num = $('[data-w-fit-num]', sec), out = $('[data-w-fit-out]', sec);
      const lab = $('[data-w-fit-label]', sec), res = $('[data-w-fit-res]', sec), rl = $('[data-w-fit-reslabel]', sec), note = $('[data-w-fit-note]', sec);
      const pick = $('[data-w-fit-pick]', sec);
      if (!range || !res) return;
      let rules = [], mode = {}, radio = null;
      const empty = msg => { res.textContent = '—'; if (note) note.textContent = msg || ''; if (pick) pick.hidden = true; radio = null; };
      const show = raw => {
        if (out) out.textContent = isNaN(raw) ? '' : fmtNum(raw) + ' cm';
        if (isNaN(raw)) return empty(mode.note);
        const v = fitRound(raw, mode.step, mode.round);
        const r = rules.find(x => v >= x.min && v <= x.max);
        if (!r) return empty(mode.nores || mode.note);
        const parts = r.out.split('|');
        res.textContent = fillTokens(parts[0].trim(), v, false);
        if (note) note.textContent = mode.note || '';
        if (pick) {
          radio = findSizeRadio(parts[1] ? fillTokens(parts[1].trim(), v, true) : '');
          pick.hidden = !radio;
          if (radio) {
            /* Taille épuisée pour les autres options choisies : on l'annonce au lieu de la proposer */
            const lab = radio.closest('label');
            const soldOut = radio.disabled || !!(lab && (lab.classList.contains('is-unavailable') || lab.classList.contains('disabled')));
            pick.disabled = soldOut;
            pick.classList.toggle('is-soldout', soldOut);
            pick.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
            pick.textContent = ((soldOut ? pick.dataset.soldout : pick.dataset.label) || pick.dataset.label || '[size]').split('[size]').join(radio.value);
            if (soldOut) radio = null;
          }
        }
      };
      const select = btn => {
        $$('.w-seg button', sec).forEach(b => b.setAttribute('aria-pressed', b === btn));
        rules = parseRules(btn.dataset.rules);
        mode = { step: parseFloat(btn.dataset.step) || 1, round: btn.dataset.round || 'near', note: btn.dataset.note || '', nores: btn.dataset.nores || '' };
        range.min = btn.dataset.min || 0; range.max = btn.dataset.max || 100; range.step = btn.dataset.step || 1; range.value = btn.dataset.default || 50;
        if (num) { num.min = range.min; num.max = range.max; num.step = range.step; num.value = range.value; }
        if (lab) lab.textContent = btn.dataset.label || '';
        if (rl) rl.textContent = btn.dataset.result || '';
        show(parseFloat(range.value));
      };
      $$('.w-seg button', sec).forEach(b => b.addEventListener('click', () => select(b)));
      range.addEventListener('input', () => { if (num) num.value = range.value; show(parseFloat(range.value)); });
      if (num) num.addEventListener('input', () => {
        const v = parseFloat(String(num.value).replace(',', '.'));
        if (!isNaN(v)) range.value = Math.min(+range.max, Math.max(+range.min, v));
        show(v);
      });
      if (pick) pick.addEventListener('click', () => {
        if (!radio) return;
        const size = radio.value;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        const d = sec.closest('dialog');
        if (d && d.open) d.close();
        if (pick.dataset.done) toast(pick.dataset.done.split('[size]').join(size));
      });
      const first = $('.w-seg button', sec); if (first) select(first);
    });
  }

  /* ---------- Fenêtres (Trouver ma taille) : <dialog data-w-dlg>, ouvertes par [data-w-dlg-open][aria-controls] ---------- */
  function initDialogs() {
    $$('[data-w-dlg-open]').forEach(b => {
      const d = document.getElementById(b.getAttribute('aria-controls'));
      if (!d) return;
      b.addEventListener('click', () => {
        if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
        document.documentElement.classList.add('w-lock');
      });
    });
    $$('dialog[data-w-dlg]').forEach(d => {
      const close = () => { if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); document.documentElement.classList.remove('w-lock'); };
      d.addEventListener('click', e => { if (e.target === d || e.target.closest('[data-w-dlg-close]')) close(); });
      d.addEventListener('close', () => document.documentElement.classList.remove('w-lock'));
    });
  }

  /* ---------- Collection : filtres et tri (v7 : « Voir plus », tiroir mobile, validation par bouton sur téléphone) ---------- */
  function initCollection() {
    const form = $('[data-w-filters]');
    if (!form) return;
    const mobile = matchMedia('(max-width: 900px)');
    let t;
    form.addEventListener('change', () => {
      if (mobile.matches && form.classList.contains('is-open')) return;
      clearTimeout(t); t = setTimeout(() => form.requestSubmit ? form.requestSubmit() : form.submit(), 250);
    });
    const sort = $('[data-w-sort]');
    if (sort) sort.addEventListener('change', () => { $('input[name=sort_by]', form).value = sort.value; form.submit(); });
    form.addEventListener('submit', () => {
      $$('input', form).forEach(i => { if ((i.type === 'number' || i.type === 'hidden') && !i.value) i.disabled = true; });
    });
    $$('[data-w-fmore]', form).forEach(body => {
      const btn = $('[data-w-fmore-btn]', body);
      if (!btn) return;
      const set = on => { body.classList.toggle('is-collapsed', !on); btn.textContent = on ? btn.dataset.less : btn.dataset.more; btn.setAttribute('aria-expanded', on); };
      set(body.hasAttribute('data-w-fmore-open'));
      btn.hidden = false;
      btn.addEventListener('click', () => set(body.classList.contains('is-collapsed')));
    });
    const tg = $('[data-w-filters-toggle]'), scrim = $('[data-w-filters-scrim]');
    const close = () => {
      form.classList.remove('is-open');
      if (scrim) scrim.hidden = true;
      document.documentElement.classList.remove('w-lock');
      if (tg) { tg.setAttribute('aria-expanded', 'false'); tg.focus(); }
    };
    if (tg) tg.addEventListener('click', () => {
      if (form.classList.contains('is-open')) return close();
      form.classList.add('is-open');
      tg.setAttribute('aria-expanded', 'true');
      if (mobile.matches) {
        if (scrim) scrim.hidden = false;
        document.documentElement.classList.add('w-lock');
        const f = $('[data-w-filters-close]', form); if (f) f.focus();
      }
    });
    $$('[data-w-filters-close]').forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && form.classList.contains('is-open')) close(); });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct() {
    const wrap = $('[data-w-product]');
    if (!wrap) return;
    const money = wrap.dataset.money;
    const variants = JSON.parse(($('[data-w-variants]', wrap) || {}).textContent || '[]');
    const form = $('[data-w-product-form]', wrap);
    const idInput = $('[data-w-variant-id]', wrap);
    const atc = $('[data-w-atc]', wrap), atcLabel = $('[data-w-atc-label]', wrap), err = $('[data-w-atc-err]', wrap);
    const priceNow = $('[data-w-price-now]', wrap), priceWas = $('[data-w-price-was]', wrap), sku = $('[data-w-sku]', wrap);
    const stickySel = $('[data-w-sticky-sel]', wrap);

    const buySel = $('[data-w-buy-sel]', wrap), buyPrice = $('[data-w-buy-price]', wrap);

    // Galerie horizontale : défilement magnétique, flèches, compteur, glisser à la souris
    const track = $('[data-w-pg-track]', wrap), count = $('[data-w-pg-count]', wrap);
    const slides = track ? $$('.w-pg__slide', track) : [];
    const slideW = () => slides[0] ? slides[0].getBoundingClientRect().width + 2 : 400;
    function pgCount() {
      if (!track || !count) return;
      const max = track.scrollWidth - track.clientWidth;
      const i = track.scrollLeft >= max - 2 ? slides.length - 1 : Math.round(track.scrollLeft / slideW());
      count.textContent = Math.min(slides.length, i + 1) + ' / ' + slides.length;
    }
    function showMedia(id) {
      if (!id || !track) return;
      const s = slides.find(x => x.dataset.wSlide == id);
      if (!s) return;
      const left = track.scrollLeft + s.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollTo({ left: left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    if (track) {
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(pgCount); }, { passive: true });
      const prev = $('[data-w-pg-prev]', wrap), next = $('[data-w-pg-next]', wrap);
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -slideW(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: slideW(), behavior: 'smooth' }));
      let drag = null;
      track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('video,iframe,model-viewer')) return; drag = { x: e.clientX, l: track.scrollLeft, moved: false }; track.classList.add('is-drag'); });
      addEventListener('pointermove', e => { if (!drag) return; const dx = e.clientX - drag.x; if (Math.abs(dx) > 3) drag.moved = true; track.scrollLeft = drag.l - dx; });
      addEventListener('pointerup', () => { if (!drag) return; drag = null; track.classList.remove('is-drag'); track.scrollTo({ left: Math.round(track.scrollLeft / slideW()) * slideW(), behavior: 'smooth' }); });
      const firstId = ($('[data-w-variant-id]', wrap) || {}).value;
      const v0 = variants.find(x => String(x.id) === String(firstId));
      if (v0 && v0.featured_media && slides.length > 1 && slides[0].dataset.wSlide != v0.featured_media.id) requestAnimationFrame(() => { const s = slides.find(x => x.dataset.wSlide == v0.featured_media.id); if (s) track.scrollLeft = s.offsetLeft - slides[0].offsetLeft; pgCount(); });
      pgCount();
    }

    function selectedOptions() {
      return $$('[data-w-option]', wrap).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    }
    function update() {
      const opts = selectedOptions();
      $$('[data-w-option]', wrap).forEach((fs, i) => { const v = $('[data-w-option-value]', fs); if (v) v.textContent = opts[i] || ''; });
      const v = variants.length === 1 ? variants[0] : variants.find(x => x.options.every((o, i) => o === opts[i])); // v8 : produit sans variante, le bouton ne passe plus à « Indisponible » après un ajout
      if (!v) { atc.disabled = true; atcLabel.textContent = str('unavailable', 'Indisponible'); if (buySel) buySel.textContent = opts.filter(Boolean).join(' / '); return; }
      idInput.value = v.id;
      priceNow.textContent = formatMoney(v.price, money);
      if (priceWas) { priceWas.hidden = !(v.compare_at_price > v.price); priceWas.textContent = v.compare_at_price ? formatMoney(v.compare_at_price, money) : ''; }
      if (sku) sku.textContent = v.sku || '';
      atc.disabled = !v.available; atcLabel.textContent = v.available ? str('addToCart', 'Ajouter au panier') : str('soldOut', 'Épuisé');
      if (stickySel) stickySel.textContent = (variants.length > 1 ? v.title + ' · ' : '') + formatMoney(v.price, money);
      if (buySel && variants.length > 1) buySel.textContent = v.title;
      if (buyPrice) buyPrice.textContent = formatMoney(v.price, money);
      if (v.featured_media) showMedia(v.featured_media.id);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      const main = $('[data-w-bundle] [data-main]'); if (main) { main.dataset.price = v.price; main.closest('label').querySelector('em').textContent = formatMoney(v.price, money); updateBundle(); }
    }
    if (form) form.addEventListener('change', e => { if (e.target.name && e.target.name.startsWith('options[')) update(); });

    // Quantité
    const q = $('[data-w-qty-input]', wrap);
    $$('[data-w-qty]', wrap).forEach(b => b.addEventListener('click', () => { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.wQty, 10)); }));

    // Aide à la taille
    $$('[data-w-sizehelp]', wrap).forEach(h => {
      const rules = parseRules(h.dataset.rules), inp = $('input', h), out = $('[data-w-sizehelp-out]', h);
      const fs = h.closest('[data-w-option]');
      inp.addEventListener('input', () => {
        const r = applyRules(rules, parseFloat(inp.value));
        out.textContent = r ? str('sizeAdvised', '→ [size] conseillé', { size: r }) : '';
        if (!r) return;
        const radio = $$('input[type=radio]', fs).find(x => x.value === r);
        if (radio && !radio.checked) { radio.checked = true; update(); }
      });
    });

    // Date de livraison estimée
    const eta = $('[data-w-eta]', wrap);
    if (eta) {
      const f = d => d.toLocaleDateString(document.documentElement.lang || 'fr', { weekday: 'short', day: 'numeric', month: 'short' });
      const now = new Date();
      $('[data-w-eta-dates]', eta).textContent = str('etaBetween', 'entre le [from] et le [to]', { from: f(addBusinessDays(now, +eta.dataset.min)), to: f(addBusinessDays(now, +eta.dataset.max)) });
    }

    // Ajout au panier sans rechargement
    if (form) form.addEventListener('submit', async e => {
      e.preventDefault();
      err.hidden = true; atc.disabled = true;
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const d = await r.json();
        if (!r.ok) throw new Error(d.description || d.message || str('addError', 'Ajout impossible'));
        toast(str('added', 'Ajouté au panier ✓'));
        refreshCartCount();
      } catch (x) { err.textContent = x.message; err.hidden = false; }
      finally { atc.disabled = false; update(); }
    });

    // Barre d'achat fixe
    const sticky = $('[data-w-sticky]', wrap);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', !on);
        $('button', sticky).tabIndex = on ? 0 : -1;
      }).observe(atc);
    }
  }

  /* ---------- Lot « souvent associés » ---------- */
  function updateBundle() {
    const b = $('[data-w-bundle]');
    if (!b) return;
    const boxes = $$('input[type=checkbox]', b).filter(i => i.checked);
    const tot = boxes.reduce((s, i) => s + (+i.dataset.price || 0), 0);
    $('[data-w-bundle-total]', b).textContent = formatMoney(tot, b.dataset.money);
    $('[data-w-bundle-count]', b).textContent = boxes.length > 1 ? str('itemsOther', '[n] articles', { n: boxes.length }) : str('itemsOne', '[n] article', { n: boxes.length });
  }
  function initBundle() {
    const b = $('[data-w-bundle]');
    if (!b) return;
    b.addEventListener('change', updateBundle);
    updateBundle();
    $('[data-w-bundle-add]', b).addEventListener('click', async () => {
      const mainId = ($('[data-w-variant-id]') || {}).value;
      const items = [];
      if (mainId) items.push({ id: +mainId, quantity: 1 });
      $$('input[data-id]', b).forEach(i => { if (i.checked) items.push({ id: +i.dataset.id, quantity: 1 }); });
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error();
        toast(str('bundleAdded', '[n] articles ajoutés ✓', { n: items.length }));
        refreshCartCount();
      } catch (e) { toast(str('bundleError', 'Ajout impossible, réessayez.')); }
    });
  }

  /* ---------- Recommandations ---------- */
  function initReco() {
    $$('[data-w-reco]').forEach(async sec => {
      try {
        const r = await fetch(sec.dataset.url);
        const html = await r.text();
        const tmp = document.createElement('div'); tmp.innerHTML = html;
        const inner = $('[data-w-reco]', tmp);
        if (inner && inner.innerHTML.trim()) sec.innerHTML = inner.innerHTML;
      } catch (e) { /* section facultative */ }
    });
  }

  /* ---------- Guide : sommaire, produit intégré, encart de taille ---------- */
  function slug(s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 60); }
  function initArticle() {
    const body = $('[data-w-article-body]');
    if (!body) return;
    const toc = $('[data-w-toc]');
    const hs = $$('h2', body);
    if (toc && hs.length > 1) {
      const ol = $('ol', toc);
      hs.forEach(h => { if (!h.id) h.id = slug(h.textContent); const li = document.createElement('li'); const a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li); });
      toc.hidden = false;
    }
    const prod = $('[data-w-inprod]', body);
    if (prod && hs.length > 2) hs[2].parentNode.insertBefore(prod, hs[2]);
    $$('[data-w-aside-helper]').forEach(a => {
      const rules = parseRules(a.dataset.rules), inp = $('input', a), out = $('output', a);
      if (!inp) return;
      const go = () => { const r = applyRules(rules, parseFloat(inp.value)); out.textContent = r ? '→ ' + r : ''; };
      inp.addEventListener('input', go);
    });
  }


  /* ---------- En-tête au défilement, catégories tactiles, grand nom, apparition des listes de produits ---------- */
  function initV3() {
    const h = $('[data-w-header]');
    if (h) addEventListener('scroll', () => h.classList.toggle('is-scrolled', scrollY > 40), { passive: true });
    $$('[data-w-xcats]').forEach(xc => xc.addEventListener('click', e => {
      const a = e.target.closest('.w-xcat'); if (!a || innerWidth > 760) return;
      const defaultOpen = a.classList.contains('is-default') && !a.classList.contains('is-closed') && !$('.is-open', xc);
      if (!a.classList.contains('is-open') && !defaultOpen) {
        e.preventDefault();
        $$('.w-xcat', xc).forEach(x => { x.classList.remove('is-open'); if (x.classList.contains('is-default')) x.classList.add('is-closed'); });
        a.classList.add('is-open'); a.classList.remove('is-closed');
      }
    }));
    const bm = $('[data-w-bigmark]');
    const fit = () => { if (!bm) return; const w = bm.parentElement.clientWidth - parseFloat(getComputedStyle(bm.parentElement).paddingLeft) * 2; bm.style.fontSize = '100px'; bm.style.fontSize = (100 * w / bm.scrollWidth) + 'px'; };
    addEventListener('resize', fit); if (document.fonts) document.fonts.ready.then(fit); fit();
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
      $$('.w-grid > li:not(.w-help):not(.w-empty)').forEach(el => {
        if (el.getBoundingClientRect().top < innerHeight) return;
        el.classList.add('w-rv');
        el.style.transitionDelay = ([...el.parentElement.children].indexOf(el) % 4) * 60 + 'ms';
        io.observe(el);
      });
    }
  }

  function init() {
    initV3(); initHeader(); initMega2(); initParallax(); initNewsletter(); initFitTool(); initDialogs(); initCollection(); initProduct(); initBundle(); initReco(); initArticle();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
